import { z } from 'zod'

export const ReviewSchema = z.object({
	id: z.string().uuid(),
	breed: z.string().uuid(),
	age: z.string().uuid(),
	title: z.string().trim().optional().nullable(),
	score: z.string().uuid().optional().nullable(),
	message: z.string().trim().min(1),
	fullName: z.string().optional(),
})

export type ReviewSchema = z.infer<typeof ReviewSchema>
